import React, { useState, useEffect } from 'react';

// SpinningNumber Component
const SpinningNumber = ({type, totalCO2, totalElectricity}) => {
    // State for the number
    const [number, setNumber] = useState(0);
    // console.log("totalCO2:", totalCO2, "totalElectricity:", totalElectricity);

    // useEffect for interval setup
    useEffect(() => {
        const interval = setInterval(() => {
            setNumber(prevNumber => prevNumber + 1);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    // Label based on type
    const label = type === 'carbon' ? 'Total CO\u2082 Emissions' : 'Total Electricity Usage';

    // Text based on type
    const text = type === 'carbon' ? 'tCO\u2082e' : 'GWh';

    // Inline styles - More compact and modern
    const styles = {
        container: {
            textAlign: 'center',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            padding: '12px 16px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '8px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            minWidth: '200px',
        },
        numberContainer: {
            perspective: '800px',
        },
        number: {
            display: 'inline-block',
            fontSize: '1.4em',
            color: '#1a1a1a',
            fontWeight: '600',
            margin: '0 8px',
            transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
            transformStyle: 'preserve-3d',
            width: 'auto',
            textAlign: 'center',
            overflow: 'hidden',
            lineHeight: '1.2',
        },
        label: {
            marginTop: '0',
            marginBottom: '8px',
            fontSize: '0.9em',
            color: '#666',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
        button: {
            marginTop: '16px',
            padding: '8px 16px',
            fontSize: '0.9em',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            cursor: 'pointer',
            outline: 'none',
        }
    };

    // Function to format the value with commas and round to 2 decimal places
    const formatValue = (value) => {
        if (!value || isNaN(value)) return '0';
        return (Math.round(value * 100) / 100).toLocaleString();
    };

    return (
        <div style={styles.container}>
            <div style={styles.label}>{label}</div>
            <div style={styles.numberContainer}>
                <div style={{...styles.number, transform: `rotateX(${-number * 360}deg)`}}>
                    {type === 'carbon' ? formatValue(totalCO2) : formatValue(totalElectricity)} {text}
                </div>
            </div>
        </div>
    );
};

export default SpinningNumber;
